import {
  Component,
  Input,
  ViewEncapsulation,
  ChangeDetectionStrategy,
} from '@angular/core';
import { MatGridListModule } from '@angular/material/grid-list';
import { TemplateGeneratorComponent } from '../template-generator/template-generator.component';
import { DynamicComponentComponent } from '../dynamic-component/dynamic-component.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { Gridster, GridsterItem } from 'angular-gridster2';

@Component({
  selector: 'app-template-generator-static',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatGridListModule,
    DynamicComponentComponent,
    Gridster,
    GridsterItem,
  ],
  templateUrl: './template-generator-static.component.html',
  styleUrl: './template-generator-static.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  encapsulation: ViewEncapsulation.None,
})
export class TemplateGeneratorStaticComponent {
  selectedCustomComponentStaticName: string | null = null;
  //Input mode, 3 readonly options, desktop = 1, tablet = 2, mobile = 3
  @Input() mode: 1 | 2 | 3 = 1;

  @Input() parentComponent: TemplateGeneratorComponent;

  constructor(parentComponent: TemplateGeneratorComponent) {
    this.parentComponent = parentComponent;
  }
}
